export default class ProductCarousel {
    constructor() {
        if ($('.related-carousel')[0]) {

            $('.related-carousel').slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              dots: false,
              arrows: true,
              responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 4,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 575,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            });
          }

      if($('.related-container .related-carousel .product-slide .product-slide-inner h4')[0]) {
        $('.related-container .related-carousel .product-slide .product-slide-inner h4').matchHeight({
          byRow: true,
        });
      }
    }
}

new ProductCarousel();


// WEBPACK FOOTER //
// ../views/modules/product-carousel/assets/js/product-carousel.js